import SubHeader from "./SubHeader"

export default  SubHeader;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/index.js